import {BasicButton} from '@packages/ui';
import Link from 'next/link';

export const EntryButton: React.FC<{
  entryURL: string;
  isLarge?: boolean;
}> = ({entryURL, isLarge = true}) => {
  return (
    entryURL && (
      <div className={isLarge ? 'mt-16 pc:w-[60%] pc:mx-auto' : 'mb-8'}>
        <Link href={entryURL} passHref target="_blank">
          <BasicButton
            label="エントリーする"
            className={isLarge ? 'pc:h-[60px]' : 'pc:h-[40px]'}
            isPrimary={true}
            isLarge={isLarge}
          />
        </Link>
      </div>
    )
  );
};
